import { Header } from '@/components/compound-components/header';
import { Toaster } from '@/components/shadcn/toaster';
import { useOrganizationContext } from '@/contexts/organization-context';
import { CopilotKit } from '@copilotkit/react-core';

export function RootLayout({ children }: { children: React.ReactNode }) {
  const { organizationId } = useOrganizationContext();

  return (
    <>
      <CopilotKit runtimeUrl='/api/copilotkit' threadId={organizationId}>
        <Header />
        <main>{children}</main>
        <Toaster />
      </CopilotKit>
    </>
  );
}
